<template>
  <div>
    <div class="columns">
      <div class="column is-10">
        <div class="is-flex flex-wrap justify-content-center-touch">
          <div class="is-flex justify-content-center-touch mb-2">
            <div
                v-if="show"
                class="is-flex align-center"
            >
              <strong style="margin-right: 1rem;">Filter:</strong>
              <div
                  class="dropdown"
                  :class="{'is-active': isActive}"
                  @click="isActive = !isActive"
              >
                <div class="dropdown-trigger">
                  <button
                      class="button"
                      aria-haspopup="true"
                      aria-controls="dropdown-menu"
                  >
                    <span>{{ activeRegion }}</span>
                    <span class="icon is-small">
                        <i
                            class="far fa-angle-down"
                            aria-hidden="true"
                        />
                      </span>
                  </button>
                </div>
                <div
                    class="dropdown-menu is-fullwidth"
                    role="menu"
                >
                  <div class="dropdown-content">
                    <a
                        v-for="region in regions"
                        class="navbar-item"
                        @click="switchRegion(region)"
                    >{{ region }}</a>
                  </div>
                </div>
              </div>
            </div>
            <div
                v-if="show"
                class="is-flex align-center ml-2"
            >
              <div
                  class="dropdown"
                  :class="{'is-active': isActiveStyle}"
                  @click="isActiveStyle = !isActiveStyle"
              >
                <div class="dropdown-trigger">
                  <button
                      class="button"
                      aria-haspopup="true"
                      aria-controls="dropdown-menu"
                  >
                    <span>Style</span>
                    <span class="icon is-small">
                        <i
                            class="far fa-angle-down"
                            aria-hidden="true"
                        />
                      </span>
                  </button>
                </div>
                <div
                    class="dropdown-menu is-fullwidth"
                    role="menu"
                >
                  <div class="dropdown-content">
                    <a
                        class="navbar-item"
                        @click="styleGrid = false"
                    >List</a>
                    <a
                        class="navbar-item"
                        @click="styleGrid = true"
                    >Grid</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="is-flex align-center ml-2 mb-2">
            <div class="field">
              <input
                  v-if="show"
                  v-model="search"
                  class="input"
                  placeholder="Find a player"
              >
            </div>
          </div>
        </div>
      </div>
      <div
          v-if="show"
          class="column is-2 has-text-right"
      >
        <button
            v-if="user && user.isHost"
            class="button is-info"
            @click="print()"
        >
          <i class="far fa-print mr-1"/>
          Print Page
        </button>
      </div>
    </div>
    <div
        v-if="show"
        class="columns"
    >
      <div
          v-if="tabHeaderLabel"
          class="column is-12 text-center"
      >
          <span class="pointHeaderLabel">
            {{ tabHeaderLabel }}
          </span>
      </div>
    </div>
    <div class="columns">
      <div
          v-if="tabHelpText"
          class="column is-12 text-center"
      >
          <span class="pointHeaderLabel">
            <a
                :href="tabHelpLink"
                _target="top"
            >{{ tabHelpText }}</a>
          </span>
      </div>
    </div>
    <div class="columns">
      <div
          v-if="special_text"
          class="column is-12 text-center"
      >
        <div v-html="special_text"/>
      </div>
    </div>
    <div
        v-if="show"
        class="columns"
    >
      <div class="column is-12">
        <div
            v-if="!styleGrid"
            class="box"
        >
          <transition-group
              name="players-list"
              tag="div"
              :css="false"
          >
            <div
                v-for="(player, index) in paginatedPlayers()"
                :key="`${index}-${player['AHL Num']}`"
                class="border-bottom is-flex flex-row space-between align-center p-1 standingCard relative"
            >
              <div class="is-flex flex-row align-center justify-content-center-touch">
                <div
                    class="num text-center"
                    :class="{'num-first': player.position === 1, 'num-second': player.position === 2, 'num-third': player.position === 3}"
                >
                  {{ player.position }}
                </div>
                <div class="ml-4">
                  <router-link
                      :to="{path: `/players/${player['AHL Num']}`}"
                      class="mr-1 is-block"
                  >
                    {{ player.Name }}
                    <small class=" has-text-dark">{{ player['AHL Num'] }}</small>
                  </router-link>
                  <div>
                    <small v-if="player['Additional Info']">
                      <small class="has-text-info">{{ player['Additional Info'] }}</small>
                    </small>
                  </div>
                  <div>
                    <div
                        v-for="(field, fldindex) in array_keys(index)"
                        :key="`${fldindex}-${field}`"
                    >
                      <small v-if="is_allowed_key(field)">
                        <small class="mr-1">{{ field }}:</small>
                        <small class="has-text-info">{{ player[field] }}</small>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mobile-block">
                <router-link
                    :to="{path: `/players/${player['AHL Num']}`}"
                    class="btn-icon tooltip"
                    data-tooltip="View Player Page"
                >
                  <i class="far fa-address-card" />
                </router-link>
                <a
                    class="btn-icon tooltip"
                    data-tooltip="Add to Friends list"
                    @click="addFriend(player['AHL Num'])"
                >
                  <i class="far fa-user-plus" />
                </a>
              </div>
            </div>
          </transition-group>
        </div>
        <div
            v-if="styleGrid"
            class="style-grid"
        >
          <div
              class="column is-12 is-flex"
              style="flex-wrap: wrap;"
          >
            <article
                v-for="(player, index) in paginatedPlayers()"
                :key="`${index}-${player['AHL Num']}`"
                class="box media winner-card"
            >
              <modale-image
                  :ref="`modal-${index}`"
                  style="display: none"
                  :image="player.memberphoto"
                  @closeModal="closeModal"
              />
              <figure class="media-left">
                <img
                    v-if="!player.memberphoto"
                    src="/images/profile.png"
                    alt="Image"
                    @click="previewImage(index)"
                >
                <img
                    v-if="player.memberphoto"
                    :src="player.memberphoto"
                    alt="Image"
                    @click="previewImage(index)"
                >
              </figure>
              <div class="media-content">
                <div
                    class="content"
                    style="width: 75%;"
                >
                  <router-link :to="{path: `/players/${player['AHL Num']}`}">
                    <a>{{ player.Name }}</a>
                    <br>
                    <span class="has-text-dark">{{ player['AHL Num'] }}</span>
                  </router-link>
                  <div
                      v-for="(field, fldindex) in array_keys(index)"
                      :key="`${fldindex}-${field}`"
                  >
                    <p v-if="is_allowed_key(field)">
                      {{ field }}:
                      <small class="has-text-info is-size-7">{{ player[field] }}</small>
                    </p>
                  </div>
                </div>
                <div
                    class="num absolute text-center"
                    :class="{'num-first': player.position === 1, 'num-second': player.position === 2, 'num-third': player.position === 3}"
                >
                  {{ player.position }}
                </div>
                <div class="mobile-block">
                  <router-link
                      :to="{path: `/players/${player['AHL Num']}`}"
                      class="btn-icon tooltip"
                      data-tooltip="View Player Page"
                  >
                    <i class="far fa-address-card" />
                  </router-link>
                  <a
                      class="btn-icon tooltip"
                      data-tooltip="Add to Friends list"
                      @click="addFriend(player['AHL Num'])"
                  >
                    <i class="far fa-user-plus" />
                  </a>
                </div>
              </div>
            </article>
          </div>
        </div>
        <pagination
            :pagination="pagination"
            per-page="50"
            :total="players.length"
            @paginateMinus="paginateMinus"
            @paginatePlus="paginatePlus"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../helpers/Pagination.vue'
export default {
  name: "RaceTab",
  props:["standingData", "show", "user", "token", "activeRegion"],
  components:{
    Pagination
  },
  computed: {
    searchFilter() {
      if (!this.players) return false
      if (isNaN(this.search)) return this.players.filter(p => p.Name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1)
      return this.players.filter(p => p['AHL Num'].indexOf(this.search) !== -1)
    }
  },
  mounted() {
    if (this.show) {
      this.standing = this.standingData
      this.tabHeaderLabel = this.standingData.headerLabel
      this.tabHelpText = this.standingData.helptext
      this.tabHelpLink = this.standingData.helplink
      this.special_text = this.standingData.special_text
      this.players = this.standingData.pointList
    }
  },
  data() {
    return {
      standing: '',
      players: [],
      search: '',
      isActiveStyle: false,
      styleGrid: false,
      regions: [
        732,
        733
      ],
      isActive: false,
      pagination: 0,
      showPreviewIndex: '',
      tabHeaderLabel: '',
      tabHelpText: null,
      tabHelpLink: null,
      special_text: null
    }
  },
  methods:{
    print() {
      if (!this.players) return false
      this.$router.push({name: 'RacesPrint', params: {players: this.players, region: this.activeRegion}})
    },
    is_allowed_key(field) {
      return (
          field !== 'AHL Num' &&
          field !== 'Name' &&
          field !== 'position' &&
          field !== 'memberphoto' &&
          field !== 'Handle' &&
          field !== 'State'
      )
    },
    array_keys(index) {
      return Object.keys(this.players[index])
    },
    closeModal() {
      this.$refs[`modal-${this.showPreviewIndex}`][0].$el.style.display = 'none'
      this.showPreviewIndex = ''
    },
    previewImage(index) {
      this.showPreviewIndex = index
      if (this.$refs[`modal-${index}`][0].$el.getAttribute('style') === 'display: none;') {
        this.$refs[`modal-${index}`][0].$el.style.display = 'block'
      } else this.$refs[`modal-${index}`][0].$el.style.display = 'none'
    },
    fullName(player) {
      let arr = player.Name.split(' ')
      if (player.Handle) {
        arr.splice(2, 0, `"${player.Handle}"`)
      }
      return arr.join(' ')
    },
    addFriend(id) {
      this.$axios({
        method: 'POST',
        url: `member/addfriend/${this.token}/${id}`,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data: {
          token: this.token
        }
      })
          .then((res) => {
            this.$emit('message',
                {
                  showDialog: true,
                  error: false,
                  message: res.data.message
                })
          })
          .catch((error) => {
            this.$emit('message',
                {
                  showDialog: true,
                  error: true,
                  message: error.response.data.message
                })
          })
    },
    paginatedPlayers() {
      if (!this.searchFilter) return ''
      return this.searchFilter.slice(this.pagination, this.pagination + 50)
    },
    paginatePlus() {
      if (this.players.length > (this.pagination + 50)) {
        this.pagination += 50
      }
    },
    paginateMinus() {
      if (this.pagination >= 50) {
        this.pagination -= 50
      }
    },
    switchRegion(region) {
      this.$emit('switchRegion', region)
    }
  }

}
</script>
<style scoped>
.pointHeaderLabel a {
  color: #FFF;
}
</style>